import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FiPhone, FiMail, FiCheck} from "react-icons/fi";
import { useRecaptcha } from "../Components/ReCaptcha";

const Enquiry = () => {
  useEffect(() => {
    document.title =
      "Transportation & Logistics Enquiry | Shivam Transworld";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Submit your transportation requirement and get a customized logistics quote from our experienced operations team."
      );
    }

       const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://shivamtransworld.in/enquiry");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Transportation & Logistics Enquiry | Shivam Transworld"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Submit your transportation requirement and get a customized logistics quote from our experienced operations team."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://shivamtransworld.in/enquiry");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Transportation & Logistics Enquiry | Shivam Transworld"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Submit your transportation requirement and get a customized logistics quote from our experienced operations team."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }
  }, []);

useEffect(() => {
  const hash = window.location.hash;
  if (hash) {
    const el = document.querySelector(hash);
    if (el) {
      const yOffset = -120; // navbar height
      const y =
        el.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }
}, []);


  const fetchCities = async (query, setSuggestions) => {
  if (query.length < 2) {
    setSuggestions([]);
    return;
  }

  try {
    const res = await fetch(
      `https://photon.komoot.io/api/?q=${query}&limit=8`
    );
    const data = await res.json();

    const cities = data.features.map(
      (item) =>
        `${item.properties.name}, ${item.properties.state || ""}`
    );

    setSuggestions(cities);
  } catch (err) {
    console.error(err);
    setSuggestions([]);
  }
};

const [fromSuggestions, setFromSuggestions] = useState([]);
const [toSuggestions, setToSuggestions] = useState([]);
const [showOtpModal, setShowOtpModal] = useState(false);
const [mobile, setMobile] = useState("");
const [sending, setSending] = useState(false);

const [step, setStep] = useState("mobile"); 
const [otp, setOtp] = useState("");
const [verifying, setVerifying] = useState(false);
const [isVerified, setIsVerified] = useState(false);

  const [form, setForm] = useState({
  fromCity: "",
  toCity: "",
  truckType: "",
  tonnage: "",
});
  const [loading, setLoading] = useState(false);
  const [vehicleType, setVehicleType] = useState("");
  const generateToken = useRecaptcha();


     const truckOptions = [
  "Closed/Container Truck",
  "Open Truck",
];

const tonnageOptions = [
  "0.5T - 5T",
  "5T - 10T",
  "10T+",
];


  // Handle input change
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Handle form submit
const handleSubmit = (e) => {
  e.preventDefault();

  if (!form.fromCity || !form.toCity || !form.truckType || !form.tonnage || !vehicleType) {
    toast.error("Please complete all selections");
    return;
  }

  setLoading(true);

  generateToken(async (token) => {

  console.log("Recaptcha Token:", token);

  try {
    const recaptchaData = new FormData();
    recaptchaData.append("secret", "6LcxfIEsAAAAACXphtu7AnEUYt8vo0_E12rS5hBA"); // 🔴 put your secret key
    recaptchaData.append("response", token);

    const res = await axios.post(
      "https://api.sendmail.adhyaynam.in/recaptcha-verify",
      recaptchaData,
      {
        headers: {
          accept: "multipart/form-data",
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log("Recaptcha Score:", res.data.score);

    if (res.data.score >= 0.5) {

  if (isVerified) {
    // already verified → submit directly
    sendEnquiry();
  } else {
    // not verified → open OTP modal
    setShowOtpModal(true);
  }

} else {
  toast.error("Suspicious activity detected. Please try again.");
}

  } catch (err) {
    console.log(err);
    toast.error("Verification failed. Please try again.");
  } finally {
    setLoading(false);
  }

});
};
  const handleTonnageChange = (e) => {
  if (!form.truckType) {
    toast.warning("Please select truck type first");
    return;
  }

  setForm({ ...form, tonnage: e.target.value });
};

const vehicleOptionsMap = {
  "Closed/Container Truck": {
    "0.5T - 5T": ["TATA ACE 0.7T", "Bolero Pik-Up 1.5T", "TATA 407 2.5T", "14FT SXL 2.5T", "17FT SXL 5T"],
    "5T - 10T": ["17FT SXL 5T", "20FT SXL 6T", "24FT SXL 7T", "32FT SXL 7T", "32FT SXL 9T", ],
    "10T+": ["32FT MXL 15T", "32FT MXL 18T", "34FT MXL 15T", "34FT MXL 18T", "4 TYRE 14FT"],
  },
  "Open Truck": {
    "0.5T - 5T": ["4 Tyre (14FT)","BOLERO 9/10FT"],
    "5T - 10T": ["4 Tyre (14FT)", "6 Tyre (19FT)", "6 Tyre (22FT)"],
    "10T+": ["6 Tyre (22FT)", "10 Tyre", "12 Tyre", "14 Tyre", "16 Tyre", "18 Tyre", "22 Tyre", "4 TYRE 14FT"],
  },
};

const vehicleOptions =
  form.truckType && form.tonnage
    ? vehicleOptionsMap[form.truckType]?.[form.tonnage] || []
    : [];

const showRouteTitle =
  form.fromCity.trim() !== "" && form.toCity.trim() !== "";

  const sendOtpHandler = async () => {
  if (mobile.length !== 10) {
    toast.error("Enter valid mobile number");
    return;
  }

  try {
    const res = await fetch(
      "https://api.shivamtransworld.in/send-otp.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ mobile }),
      }
    );

    const data = await res.json();

    if (data.status) {
      toast.success("OTP sent successfully");
      setStep("otp"); // move to OTP step
    } else {
      toast.error(data.message);
    }
  } catch (err) {
    toast.error("Failed to send OTP");
  }
};

const verifyOtpHandler = async () => {
  if (!otp) {
    toast.error("Enter OTP");
    return;
  }

  try {
    setVerifying(true);

    const res = await fetch(
      "https://api.shivamtransworld.in/verify-otp.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ mobile, otp }),
      }
    );

    const data = await res.json();

    if (data.status) {
      toast.success("Verified successfully ✅");
      setIsVerified(true);

      // ✅ NOW CALL YOUR EXISTING FUNCTION
      await sendEnquiry();

    } else {
      toast.error(data.message);
    }
  } catch (err) {
    toast.error("Verification failed");
  } finally {
    setVerifying(false);
  }
};

  const sendEnquiry = async () => {
      if (mobile.length !== 10) {
    toast.error("Please enter a valid mobile number");
    return;
  }
  try {

    setSending(true); // START LOADING

    const shivampayload = {
      token:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.Z1HYUFpb0qLZ-uus95HoinkruzbwRy-JN-dSHXBOl1I.rpuUl2Nre3tW3b_H9RdpeZL9GAFHuSZTA4K7aCkNJwA",
      campaignName: "New Transport Requirement",
      destination: "+919132287287",
      userName: "Shivam Transworld",
      components: [
    {
      type: "body",
      parameters: [
        {
          type: "text",
          text: form.fromCity
        },
        {
          type: "text",
          text: form.toCity,
        },
        {
          type: "text",
          text: form.truckType,
        },
        {
          type: "text",
          text: form.tonnage,
        },
        {
          type: "text",
          text: vehicleType,
        },
        {
          type: "text",
          text: mobile
        }
      ]
    }
  ],
    };

     const clientpayload = {
      token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.Z1HYUFpb0qLZ-uus95HoinkruzbwRy-JN-dSHXBOl1I.rpuUl2Nre3tW3b_H9RdpeZL9GAFHuSZTA4K7aCkNJwA",
      campaignName: "Transport Request Received",
      destination: `{+91${mobile}}`,
      userName: "Shivam Transworld",
      components: [
    {
      type: "body",
      parameters: [
        {
          type: "text",
          text: form.fromCity,
        },
        {
          type: "text",
          text: form.toCity,
        },
        {
          type: "text",
          text: form.truckType,
        },
        {
          type: "text",
          text: form.tonnage,
        },
        {
          type: "text",
          text: vehicleType,
        }
      ]
    }
  ],
    };

    // CALL BOTH APIS TOGETHER
    await Promise.all([
  axios.post(
    "https://api.onbbits.io/api/campaigns/send",
    shivampayload,
    { headers: { "Content-Type": "application/json" } }
  ),
  axios.post(
    "https://api.onbbits.io/api/campaigns/send",
    clientpayload,
    { headers: { "Content-Type": "application/json" } }
  ),
]);
    toast.success("Enquiry submitted successfully 📲");

    // RESET FORM
    setShowOtpModal(false);
    setIsVerified(false);

    setForm({
      fromCity: "",
      toCity: "",
      truckType: "",
      tonnage: "",
    });

    setVehicleType("");
    setMobile("");
      setStep("mobile");
setOtp("");

  } catch (error) {
    console.error(error);
    toast.error("Something went wrong. Please try again.");
  } finally {
    setSending(false); // STOP LOADING (VERY IMPORTANT)
  }

};

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="spacing-div"></div>

           <section className="hero enquiry-pg">
        <div className="hero-overlay">
           <motion.h1
      className="hero-title"
      key={showRouteTitle ? "route" : "default"}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {showRouteTitle
        ? `Explore Price Of FTL Vehicle From ${form.fromCity} To ${form.toCity}`
        : "Enquire Now"}
    </motion.h1>

    {/*{!showRouteTitle && (
      <motion.p
        className="hero-text"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.15, duration: 0.6, ease: "easeOut" }}
      >
        Whether you need a closed container or open truck, our experienced logistics team ensures the right vehicle, right capacity, and timely delivery for every shipment.
      </motion.p>
    )}*/}
        </div>
      </section>

      <section className="quote-section" id="enquiry-form">
        <motion.div
          className="quote-wrapper"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          {/* HEADER */}
    <motion.h2 className="form-heading">
  Enter route details below to check prices
</motion.h2>

          <motion.p
            className="quote-subtitle"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.25, duration: 0.6 }}
            viewport={{ once: true }}
          >
           Request a quick and accurate transportation quote tailored to your shipment requirements and delivery needs. 
          </motion.p>

          {/* FORM */}
       <motion.form className="quote-form horizontal" onSubmit={handleSubmit} >
  <div className="form-grid">

    {/* From City */}
    <div className="autocomplete">
      <input
        type="text"
        placeholder="From City"
        value={form.fromCity}
        onChange={(e) => {
          const value = e.target.value;
          setForm({ ...form, fromCity: value });

          if (value.trim().length < 2) {
            setFromSuggestions([]);
            return;
          }

          fetchCities(value, setFromSuggestions);
        }}
        required
      />

      {form.fromCity.trim().length > 1 && fromSuggestions.length > 0 && (
        <ul className="suggestions">
          {fromSuggestions.map((city, i) => (
            <li
              key={i}
              onClick={() => {
                setForm({ ...form, fromCity: city });
                setFromSuggestions([]);
              }}
            >
              {city}
            </li>
          ))}
        </ul>
      )}
    </div>

    {/* To City */}
    <div className="autocomplete">
      <input
        type="text"
        placeholder="To City"
        value={form.toCity}
        onChange={(e) => {
          const value = e.target.value;
          setForm({ ...form, toCity: value });

          if (value.trim().length < 2) {
            setToSuggestions([]);
            return;
          }

          fetchCities(value, setToSuggestions);
        }}
        required
      />

      {form.toCity.trim().length > 1 && toSuggestions.length > 0 && (
        <ul className="suggestions">
          {toSuggestions.map((city, i) => (
            <li
              key={i}
              onClick={() => {
                setForm({ ...form, toCity: city });
                setToSuggestions([]);
              }}
            >
              {city}
            </li>
          ))}
        </ul>
      )}
    </div>

    {/* Truck Type */}
    <select
      name="truckType"
      value={form.truckType}
      onChange={handleChange}
      required
    >
      <option value="">Select TruckType</option>
      {truckOptions.map((truck, i) => (
        <option key={i} value={truck}>
          {truck}
        </option>
      ))}
    </select>

    {/* Tonnage */}
    <select
      name="tonnage"
      value={form.tonnage}
      onChange={handleTonnageChange}
      required
    >
      <option value="">Select Tonnage Range</option>
      {tonnageOptions.map((ton, i) => (
        <option key={i} value={ton}>
          {ton}
        </option>
      ))}
    </select>

    {/* Submit Button */}
    <button
      type="submit"
      className="quote-btn inline-btn"
      disabled={loading}
    >
      {loading ? "Checking..." : "Check Price"}
    </button>

  </div>
</motion.form>
{vehicleOptions.length > 0 && (
  <motion.div
    className="vehicle-options-row"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4, ease: "easeOut" }}
  >
    {vehicleOptions.map((vehicle, i) => (
      <div
        key={i}
        className={`vehicle-box ${
          vehicleType === vehicle ? "active" : ""
        }`}
        onClick={() => setVehicleType(vehicle)}
      >
        {vehicle}
      </div>
    ))}
  </motion.div>
)}


        </motion.div>

        {/* INFO BOXES */}
        <motion.div
          className="quote-info"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: { transition: { staggerChildren: 0.15 } },
          }}
        >
          {/* LEFT */}
          <motion.div
            className="info-card"
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: { opacity: 1, y: 0 },
            }}
          >
            <h2 className="section-title">Why Fill This Form?</h2>
            <ul>
    <li>
      <FiCheck />
      Quick response from logistics team
    </li>
    <li>
      <FiCheck />
      Customized transport planning
    </li>
    <li>
      <FiCheck />
      No obligation quote
    </li>
  </ul>
          </motion.div>

          {/* RIGHT */}
          <motion.div
            className="info-card"
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: { opacity: 1, y: 0 },
            }}
          >
            <h2 className="section-title">Contact Information</h2>
            <ul>
             <li>
  <motion.span
    initial={{ scale: 0 }}
    whileInView={{ scale: 1 }}
    transition={{ type: "spring", stiffness: 250 }}
    viewport={{ once: true }}
  >
    <FiPhone />
  </motion.span>

  <a href="tel:+919132287287">
    +91 9132 287 287
  </a>
</li>

<li>
  <motion.span
    initial={{ scale: 0 }}
    whileInView={{ scale: 1 }}
    transition={{ type: "spring", stiffness: 250, delay: 0.1 }}
    viewport={{ once: true }}
  >
    <FiMail />
  </motion.span>

  <a href="mailto:logistics@shivamtransworld.in">
    logistics@shivamtransworld.in
  </a>
</li>

            </ul>
          </motion.div>
        </motion.div>
      </section>

{showOtpModal && (
  <div className="otp-overlay">
    <div className="otp-modal">

      <h3>Verify Mobile Number</h3>

      {step === "mobile" && (
        <>
          <p>Enter your mobile number</p>

          <input
            type="tel"
            placeholder="Enter mobile number"
            value={mobile}
            maxLength={10}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              setMobile(value);
            }}
          />

          <button
            className="otp-btn"
            disabled={mobile.length !== 10}
            onClick={sendOtpHandler}
          >
            Send OTP
          </button>
        </>
      )}

      {step === "otp" && (
        <>
          <p>Enter OTP sent to {mobile}</p>

          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            maxLength={6}
            onChange={(e) => setOtp(e.target.value)}
          />

         <button
  className="otp-btn"
  disabled={otp.length < 4 || verifying || sending}
  onClick={verifyOtpHandler}
>
  {verifying || sending ? "Processing..." : "Verify OTP"}
</button>
        </>
      )}

      <span
        className="otp-close"
        onClick={() => {
          setShowOtpModal(false);
          setMobile("");
          setOtp("");
          setStep("mobile");
        }}
      >
        ✕
      </span>

    </div>
  </div>
)}
    </>
  );
};

export default Enquiry;
